import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
	xhrClinicalGetPatHistoryExamsRef,
	xhrClinicalGetBundledExamsByExamId,
	xhrClinicalGetReportViewById,
	xhrClinicalGetExamsByUniqueIds,
} from "../../../utilities/xhr-clinical";
import { xhrInstGetInstitutionById } from "../../../utilities/xhr-inst";
import { xhrPatientGetPatientById } from "../../../utilities/xhr-patient";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
import { UpdateUserPreferences } from "../../../redux/actions/account-action-types";
import { toastUtil, toastUtilText } from "../../../utilities/toast-util";
import { DicomViewer } from "../../../utilities/dicom-viewer";
import ReviewTopMenuButtonPanels from "./ReviewTopMenuButtonPanels.js";
import ReviewTopMenuContent from "./ReviewTopMenuContent/ReviewTopMenuContent.js";
import ReportViewer from "../../../components/ReportViewer";
import AreaBookmark from "../../../components/AreaBookmark";
import RangeSlider from "react-bootstrap-range-slider";

function ExamReview() {
	let { id: cei } = useParams();

	const dispatch = useDispatch();
	const history = useHistory();
	const [acn, setAcn] = React.useState(
		new URLSearchParams(window.location.search).get("acn")
	);
	const [tid, setTid] = React.useState(
		new URLSearchParams(window.location.search).get("tid")
	);
	const [currentExamId, setCurrentExamId] = React.useState(parseInt(cei));

	/*
	Session 
	*/
	const userInfo = useSelector((state) => state?.session.userInfo);
	const sessionFilter = useSelector((state) => state.session.sessionFilter);
	const userPermissions = useSelector((state) => state.session.userPermissions);
	const userPreferences = useSelector(
		(state) => state?.session?.userPreferences
	);
	const currentLanguage = useSelector(
		(state) => state.session?.userPreferences?.language
	);
	const token = useSelector((state) => state.session.token);

	/*
	Component data
	*/

	const [previousExam, setPreviousExam] = React.useState(0);
	const [mainExam, setMainExam] = React.useState();
	//visible bundle
	const [bundledExams, setBundledExams] = React.useState([]);
	const [viewerMode, setViewerMode] = React.useState(undefined);
	const [viewerStudies, setViewerStudies] = React.useState([]);
	const [viewerMainStudiesCompare, setViewerMainStudiesCompare] =
		React.useState([]);
	const [viewerStudiesCompare, setViewerStudiesCompare] = React.useState([]);
	const [associatedReport, setAssociatedReport] = React.useState();
	const [currentInstitution, setcurrentInstitution] = React.useState(null);
	const [selectedPatient, setSelectedPatient] = React.useState(null);
	const viewerForceCompareOhif = viewerMode != "meddream";

	const [patHistoryExams, setPatHistoryExams] = React.useState();
	React.useEffect(() => {
		let mountedRef = true;
		if (mainExam?.patId) {
			const effectPromise = async () => {
				var data = await xhrClinicalGetPatHistoryExamsRef(
					token,
					mainExam?.patId,
					"date",
					"asc"
				);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setPatHistoryExams(data?.result?.data);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [mainExam?.patId, currentLanguage, token]);

	React.useEffect(() => {
		setViewerMode(
			mainExam?.tenantId === 26 || mainExam?.tenantId === 36
				? "meddream"
				: undefined
		);
	}, [mainExam]);

	React.useEffect(() => {
		setPreviousExam(history?.location?.state?.previousExam ?? 0);
	}, [history?.location?.state?.previousExam]);

	React.useEffect(() => {
		if (viewerForceCompareOhif) {
			if (viewerMainStudiesCompare?.length > 0) {
				setViewerMainStudiesCompare([]);
			}
		} else {
			setViewerMainStudiesCompare(viewerStudiesCompare);
		}
	}, [viewerForceCompareOhif, viewerStudiesCompare, viewerMainStudiesCompare]);

	/*
	Permissions
	*/

	React.useEffect(() => {
		if (acn && tid && token?.length > 0) {
			const effectPromise = async () => {
				var dataInner = await xhrClinicalGetExamsByUniqueIds(token, {
					tid: tid,
					uniqueIds: acn,
				});
				toastUtil({ currentLanguage, data: dataInner });
				if (dataInner?.result?.data?.length > 0) {
					setCurrentExamId(dataInner?.result?.data[0].id);
				}
			};
			effectPromise();
		}
	}, [acn, token, tid]);

	React.useEffect(() => {
		if (currentExamId && token?.length > 0) {
			const effectPromise = async () => {
				if (currentExamId) {
					var dataInner = await xhrClinicalGetBundledExamsByExamId(
						token,
						currentExamId
					);
					toastUtil({ currentLanguage, data: dataInner });
					if (dataInner?.result?.data) {
						var curExam = dataInner?.result?.data?.filter(
							(el) => el.id === currentExamId
						);
						if (curExam.length > 0) {
							setMainExam(curExam[0]);
							changeEnableReport(curExam[0]?.status === 64);
						}
						setBundledExams(dataInner?.result?.data);
					}
				}
			};
			effectPromise();
		}
	}, [currentExamId, token]);

	React.useEffect(() => {
		let mountedRef = true;
		if (mainExam?.reportId) {
			const effectPromise = async () => {
				var data = await xhrClinicalGetReportViewById(token, mainExam.reportId);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setAssociatedReport(data?.result?.data);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [mainExam, token, currentLanguage]);

	React.useEffect(() => {
		let mountedRef = true;
		if (mainExam?.instId) {
			const effectPromise = async () => {
				var data = await xhrInstGetInstitutionById(token, mainExam?.instId);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setcurrentInstitution(data?.result?.data);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [mainExam?.instId, token, currentLanguage]);

	React.useEffect(() => {
		let mountedRef = true;
		if (mainExam?.patId) {
			const effectPromise = async () => {
				var data = await xhrPatientGetPatientById(token, mainExam?.patId);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setSelectedPatient(data?.result?.data);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [mainExam?.patId, token, currentLanguage]);

	const [splitPaneSetter, setSplitPaneSetter] = React.useState("vertical");
	const [enableMainImages, changeEnableMainImages] = React.useState(true);
	const [showMainImages, changeShowMainImages] = React.useState(false);
	const [enableReport, changeEnableReport] = React.useState(true);
	const [showReport, changeShowReport] = React.useState(false);
	const [showDocuments, changeShowDocuments] = React.useState(
		userPreferences?.examEditorRequestOpen ?? false
	);

	React.useEffect(() => {
		if (
			bundledExams?.filter((x) => x.hasImages)?.length > 0 &&
			enableMainImages
		) {
			changeShowMainImages(true);
		}
	}, [bundledExams, enableMainImages]);

	React.useEffect(() => {
		if (enableReport && mainExam?.status === 64) {
			changeShowReport(true);
		}
	}, [enableReport, userPreferences?.examEditorReportOpen, mainExam?.status]);

	React.useEffect(() => {
		if (bundledExams) {
			Promise.allSettled(
				bundledExams?.map((x) =>
					fetch(
						`${process.env.REACT_APP_SERVER_URL}Clinical/GetExamStudyByExamId?id=${x?.id}`,
						{
							headers: {
								Authorization: `Bearer ${token}`,
							},
						}
					)
						.then((x) => x.json())
						.then((x) => {
							return x?.data?.map((e) => e.studyUid);
						})
						.then((x) => {
							return x;
						})
				)
			)
				.then((values) => values?.map((x) => x.value))
				.then((records) => {
					setViewerStudies([].concat.apply([], records));
				});
		}
	}, [bundledExams, token]);

	var hostSrv = `${process.env.REACT_APP_SERVER_URL}`;
	const hostSrvToken = useSelector((state) => state.session.token);
	const userId = useSelector((state) => state?.session.userInfo?.id);

	const [splitterPerc, changeSplitterPerc] = React.useState(50);
	const [isCompactLayout, setIsCompactLayout] = React.useState(() =>
		typeof window !== "undefined" ? window.innerWidth < 992 : false
	);
	const [compactView, setCompactView] = React.useState("report");

	useEffect(() => {
		let width = userPreferences?.examEditorImageRatio;
		if (!(10 < width && width < 90)) {
			width = 50;
		}
		changeSplitterPerc(width);
	}, userPreferences?.examEditorImageRatio);

	const [tooltipSpeechOpen, setTooltipSpeechOpen] = React.useState(false);
	const toggleSpeechTooltip = () => setTooltipSpeechOpen(!tooltipSpeechOpen);
	/*
	(0)Disabled (1)Loading (2)Ready (3) Started
	*/
	const [speechStatus, setSpeechStatus] = React.useState(0);
	const [speechMessage, setSpeechMessage] = React.useState("");

	const handleSpeech = (e) => {
		setSpeechStatus(e?.detail?.status);
		setSpeechMessage(e?.detail?.message);
	};

	React.useEffect(() => {
		document?.addEventListener(
			"medapp_dxeditor_speech_out",
			handleSpeech,
			false
		);
		return () => {
			document?.removeEventListener(
				"medapp_dxeditor_speech_out",
				handleSpeech,
				false
			);
		};
	}, []);

	React.useEffect(() => {
		const handleResize = () => {
			setIsCompactLayout(window.innerWidth < 992);
		};

		handleResize();
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const reportPdfViewerVisible = mainExam?.reportId && mainExam?.status === 64;
	const hasAvailableImages = viewerStudies?.length > 0;
	const hasAvailableReport = Boolean(reportPdfViewerVisible);
	const showCompactSelector =
		isCompactLayout && hasAvailableImages && hasAvailableReport;

	React.useEffect(() => {
		if (!showCompactSelector) {
			if (hasAvailableReport) {
				setCompactView("report");
			} else if (hasAvailableImages) {
				setCompactView("images");
			}
			return;
		}

		setCompactView((currentView) => {
			if (currentView === "report" && hasAvailableReport) return currentView;
			if (currentView === "images" && hasAvailableImages) return currentView;
			if (hasAvailableReport) return "report";
			if (hasAvailableImages) return "images";
			return currentView;
		});
	}, [showCompactSelector, hasAvailableImages, hasAvailableReport]);

	const [updatingUser, changeUpdatingUser] = React.useState(false);
	//minimum elements to build module
	if (!mainExam || !currentInstitution || !bundledExams || !selectedPatient) {
		return <div />;
	}

	const reportEditorData = {
		exams: bundledExams,
		institution: currentInstitution,
		patient: selectedPatient,
		dicom: {
			totalRadiation: 0,
		},
		readOnly: true,
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				paddingLeft: "0.5em",
				paddingTop: "0.5em",
				paddingRight: "0.5em",
			}}
		>
			<nav
				className="img-viewstyle navbar navbar-expand-lg navbar-light bg-white border-radius-4 "
				style={{ padding: "0", paddingLeft: "10px" }}
			>
				<div
					className="navbar-collapse collapse"
					id="navbarToggler01"
					style={{ maxHeight: "50px" }}
				>
					<ReviewTopMenuContent
						patHistoryExams={patHistoryExams}
						bundledExams={bundledExams}
						mainExam={mainExam}
						institution={currentInstitution}
						associatedReport={associatedReport}
						patient={selectedPatient}
						showReport={showReport}
						compareStudies={viewerStudiesCompare}
						setCompareStudies={setViewerStudiesCompare}
						showImages={showMainImages}
					/>
					<ReviewTopMenuButtonPanels
						splitPaneSetter={splitPaneSetter}
						setSplitPaneSetter={setSplitPaneSetter}
						mainExam={mainExam}
						bundledExams={bundledExams}
						enableMainImages={enableMainImages}
						showMainImages={showMainImages}
						changeShowMainImages={changeShowMainImages}
						enableReport={enableReport}
						showReport={showReport}
						changeShowReport={changeShowReport}
						enableDocuments={true}
						showDocuments={showDocuments}
						changeShowDocuments={changeShowDocuments}
						selectedExam={mainExam}
					/>
				</div>
			</nav>

			<div
				className="w-100 image-div"
				style={{ flex: "1 100%", overflow: "hidden", position: "relative" }}
			>
				{showCompactSelector && (
					<div
						style={{
							position: "fixed",
							zIndex: 1000,
							display: "flex",
							gap: "8px",
							padding: "8px",
							bottom: "max(12px, env(safe-area-inset-bottom))",
							left: "50%",
							transform: "translateX(-50%)",
							borderRadius: "10px",
							background: "rgba(255,255,255,0.92)",
							boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
						}}
					>
						<button
							type="button"
							onClick={() => setCompactView("images")}
							title="Images"
							style={{
								width: "40px",
								height: "40px",
								borderRadius: "8px",
								border: "2px solid #e78e4b",
								background: compactView === "images" ? "#e78e4b" : "#ffffff",
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								cursor: "pointer",
								boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
							}}
						>
							<i
								className="zmdi zmdi-eye zmdi-hc-lg"
								style={{ color: compactView === "images" ? "#ffffff" : "#05585E" }}
							/>
						</button>
						<button
							type="button"
							onClick={() => setCompactView("report")}
							title="Report"
							style={{
								width: "40px",
								height: "40px",
								borderRadius: "8px",
								border: "2px solid #e78e4b",
								background: compactView === "report" ? "#e78e4b" : "#ffffff",
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								cursor: "pointer",
								boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
							}}
						>
							<i
								className="zmdi zmdi-file zmdi-hc-lg"
								style={{ color: compactView === "report" ? "#ffffff" : "#05585E" }}
							/>
						</button>
					</div>
				)}
				{!showMainImages && !showReport && (
					<div className="bg-white w-100 screenshot-container bg-white p-3 border-radius-2 my-2 d-flex align-items-center justify-content-center">
						Images and report not visible
					</div>
				)}
				{
					<div
						style={{
							backgroundColor: "transparent",
							float: "left",
							height: "100%",
							width:
								showCompactSelector || !showReport
									? "100%"
									: splitterPerc + "%",
							display:
								showMainImages &&
								(!showCompactSelector || compactView === "images")
									? "block"
									: "none",
							position: "relative",
						}}
					>
						<AreaBookmark
							active={userPreferences?.examEditorImagesOpen ?? false}
							onChange={async (e) => {
								dispatch(
									UpdateUserPreferences({
										data: {
											examEditorImagesOpen:
												!userPreferences?.examEditorImagesOpen,
										},
										callback: () => {
											changeUpdatingUser(false);
										},
									})
								);
							}}
						/>
						<div
							style={{
								minHeight: "500px",
								height: "100%",
								width: "100%",
								display: "flex",
								flex: "row",
							}}
						>
							<div
								style={{
									display: viewerStudies?.length > 0 ? "block" : "none",
									position: "relative",
									height: "100%",
									width: "100%",
								}}
							>
								<DicomViewer
									mode={viewerMode}
									tenantId={mainExam?.tenantId}
									studyUids={viewerStudies}
									modality={mainExam?.tecAreaCode}
									compareStudyUids={viewerMainStudiesCompare}
									showMainImages={showMainImages}
								/>
							</div>
							<div
								style={{
									display:
										viewerForceCompareOhif && viewerStudiesCompare?.length > 0
											? "block"
											: "none",
									position: "relative",
									height: "100%",
									width: "100%",
								}}
							>
								<DicomViewer
									mode={"ohif"}
									tenantId={mainExam?.tenantId}
									studyUids={viewerForceCompareOhif ? viewerStudiesCompare : []}
									modality={mainExam?.tecAreaCode}
									showMainImages={showMainImages}
								/>
							</div>
							{viewerStudies?.length === 0 && (
								<div className="bg-white w-100 screenshot-container bg-white p-3 border-radius-2 my-2 d-flex align-items-center justify-content-center">
									Loading Images
								</div>
							)}
						</div>
					</div>
				}
				{
					<div
						style={{
							backgroundColor: "transparent",
							float: "left",
							height: "100%",
							width:
								showCompactSelector || !showMainImages
									? "100%"
									: 99.99 - splitterPerc + "%",
							display:
								showReport &&
								(!showCompactSelector || compactView === "report")
									? "block"
									: "none",
							position: "relative",
						}}
					>
						{reportPdfViewerVisible && (
							<ReportViewer reportId={mainExam?.reportId} />
						)}
					</div>
				}
			</div>
			<div
				style={{
					position: "absolute",
					bottom: "63px",
					left: "44.1%",
					width: "15%",
					display:
						showMainImages && showReport && !showCompactSelector
							? "block"
							: "none",
				}}
			>
				<RangeSlider
					min={30}
					max={70}
					variant={"success"}
					value={splitterPerc}
					onChange={(changeEvent) => {
						changeSplitterPerc(changeEvent.target.value);
						if (!updatingUser) {
							changeUpdatingUser(true);
							dispatch(
								UpdateUserPreferences({
									data: {
										examEditorImageRatio: parseInt(changeEvent.target.value),
									},
									callback: () => {
										changeUpdatingUser(false);
									},
								})
							);
						}
					}}
				/>
			</div>
		</div>
	);
}

export default ExamReview;
